import React from 'react'
import { View } from "react-native"

export const ShimmerPlaceholder = ({ visible = true, children, style, shimmerStyle, ...props }: any) => {
  if (visible) {
    return children || <View />
  }

  return (
    <View
      style={[
        {
          backgroundColor: "#E0E0E0",
          opacity: 0.7,
        },
        style,
        shimmerStyle,
      ]}
      {...props}
    />
  )
}

export const createShimmerPlaceholder = () => ShimmerPlaceholder

export default ShimmerPlaceholder
